import SettingsModal from "pages/ManagementPage/SettingsModal/SettingsModal";

export default SettingsModal;
